import { render, staticRenderFns } from "./CommandWhile.vue?vue&type=template&id=21d94940&scoped=true&"
import script from "./CommandWhile.vue?vue&type=script&lang=ts&"
export * from "./CommandWhile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d94940",
  null
  
)

export default component.exports